module.exports = __webpack_public_path__ + "static/media/66.33e9befc.jpg";